export enum LocalStorageNames {
  DashboardCalendar = 'dashboard-calendar-cache',
  CurrentUser = 'currentUser',
  EstimatePublished = 'estimate-published',
  LineItemClipboard = 'line-item-clipboard',
  BackgroundPhotos = 'background-photos-cache',
  MedicalRecordDraft = 'medical-record-draft',
  CommunicationDraft = 'communication-draft',
}
